import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
export default {
  name: 'WidgetContainer',
  props: {
    title: {
      type: String,
      default: 'Chat with us'
    },
    initialState: {
      type: String,
      default: 'minimized',
      validator: function validator(value) {
        var _context;
        return _includesInstanceProperty(_context = ['minimized', 'expanded']).call(_context, value);
      }
    },
    position: {
      type: String,
      default: 'bottom-right',
      validator: function validator(value) {
        var _context2;
        return _includesInstanceProperty(_context2 = ['bottom-right', 'bottom-left', 'top-right', 'top-left']).call(_context2, value);
      }
    }
  },
  data: function data() {
    return {
      minimized: this.initialState === 'minimized'
    };
  },
  methods: {
    toggleMinimized: function toggleMinimized() {
      this.minimized = !this.minimized;
      this.$emit('state-change', this.minimized ? 'minimized' : 'expanded');
    },
    minimize: function minimize() {
      if (!this.minimized) {
        this.minimized = true;
        this.$emit('state-change', 'minimized');
      }
    },
    expand: function expand() {
      if (this.minimized) {
        this.minimized = false;
        this.$emit('state-change', 'expanded');
      }
    }
  }
};